import { sanitizeUrl } from '@ampcore/string-format'
import React, { useEffect, useRef } from 'react'
import xss from 'xss'

export type SkipLinkProps = {
  id: string
  href: string
  targetSelector: string
  focusSelector: string | (() => void)
  label: string
  shouldFocusOnMount?: boolean
}

export const SkipLink = (props: SkipLinkProps) => {
  const { id, href, targetSelector, focusSelector, label, shouldFocusOnMount } =
    props

  const ref = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    if (shouldFocusOnMount && ref && ref.current) {
      ref.current.focus()
    }
  }, [shouldFocusOnMount])

  const handleLinkClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    targetQuerySelector: string,
    focusQuerySelector: string | (() => void)
  ) => {
    if (!targetQuerySelector) {
      return
    }
    event.preventDefault()
    try {
      (event.target as HTMLElement).blur()
      const targetElement = document.querySelector(targetQuerySelector)
      targetElement && targetElement.scrollIntoView({ behavior: 'smooth' })
      if (focusQuerySelector && typeof focusQuerySelector === 'function') {
        focusQuerySelector()
      } else {
        const focusElement = document.querySelector(
          focusQuerySelector || targetQuerySelector
        )
        focusElement && (focusElement as HTMLElement).focus()
      }
    } catch (e) {
      console.error('Error focusing on element:', e)
    }
  }

  return (
    <a
      id={id}
      href={sanitizeUrl(xss(href))}
      ref={ref}
      className="Link Link--skip"
      onClick={event => handleLinkClick(event, targetSelector, focusSelector)}
      key={label}
    >
      {label}
    </a>
  )
}
